export const SET_LPS = 'lps/SET_LPS' as const
export const APPEND_LPS = 'lps/APPEND_LPS' as const
export const SET_ACTIVE_FILTERS = 'lps/SET_ACTIVE_FILTERS' as const
export const SET_ACTIVE_SORTING = 'lps/SET_ACTIVE_SORTING' as const
export const UPDATE_LPS_ROW = 'lps/UPDATE_LPS_ROW' as const
